import { render, staticRenderFns } from "./page-prices.vue?vue&type=template&id=782544c2"
import script from "./page-prices.js?vue&type=script&lang=js&external"
export * from "./page-prices.js?vue&type=script&lang=js&external"
import style0 from "./page-prices.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports